import React from 'react';
import { Typography } from '@design-system';
import './HoursSummed.scss';
import { PiClockCountdownFill } from 'react-icons/pi';

export type HoursSummedProps = {
    hours: number;
};

export const HoursSummed: React.FC<HoursSummedProps> = ({ hours }) => {
    return (
        <div className="hours-summed">
            <div className="hours-summed-content">
                <PiClockCountdownFill viewBox="25 0 256 256" />
                <Typography intrinsic="h1">{hours}h</Typography>
            </div>

            <div className="hours-summed-content">
                <Typography intrinsic="h1" variant="sub">
                    Total des heures effectuées
                </Typography>
            </div>
        </div>
    );
};
